/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Automatically apply coupon when Klaviyo form is submitted
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
      fetch('/discount/BLOOM10')
        .then(() => {
          console.log('Discount applied to session');
        })
        .catch(err => console.error('Coupon fetch failed', err));
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
